import { render } from "./Account.vue?vue&type=template&id=5f8c59bc&scoped=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=5f8c59bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f8c59bc"

export default script